import isValidString from '../checkVarType/isValidString';

export default (string) => {
  if (!isValidString(string)) {
    return string;
  }
  return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
};
